export default __webpack_public_path__ + "static/media/undraw_upgrade_06a0.1958b6b6.svg";